import { IObjectKey } from '../interfaces'
import axios from 'axios'

interface bodyInt {
    [key: string]: any
}

export async function Data8Service(serviceType: string, service: string, body: bodyInt) {
    try {
        let axiosData = {
            method: 'POST',
            headers: { 'content-type': 'application/json; charset=utf-8' },
            url: `https://webservices.data-8.co.uk/${serviceType}/${service}.json?key=${process.env.REACT_APP_DATA8_API_KEY}`,
            timeout: 180000,
            data: body,
        }

        const response = await axios(axiosData)
        return response.data
    } catch (error) {
        return { Status: 'Error', Result: null }
    }
}
